import { JsonData } from '../types';
import { API_URL } from '../config';

export async function getJson(): Promise<JsonData> {
  const results = await fetch(API_URL);
  const data = results.json();
  return data;
}
